export default {"src":"/_next/static/media/private-office.fdbb6d47.svg","height":26,"width":30,"blurWidth":0,"blurHeight":0};